import { render, staticRenderFns } from "./ContactUsDetail.vue?vue&type=template&id=9ead583a&scoped=true"
import script from "./ContactUsDetail.vue?vue&type=script&lang=js"
export * from "./ContactUsDetail.vue?vue&type=script&lang=js"
import style0 from "./ContactUsDetail.vue?vue&type=style&index=0&id=9ead583a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ead583a",
  null
  
)

export default component.exports